import { Component, Input, OnInit } from "@angular/core";
import { MatDialog } from "@angular/material/dialog";
import { CommonLoggingProp, LoggingService } from "src/app/core";
import {
  VenueRequestWizardDialogComponent,
  VenueRequestWizardDialogResult,
} from "../venue-request-wizard-dialog/venue-request-wizard-dialog.component";

@Component({
    selector: "app-venue-request-wizard-link",
    templateUrl: "./venue-request-wizard-link.component.html",
    styleUrls: ["./venue-request-wizard-link.component.scss"],
    standalone: false
})
export class VenueRequestWizardLinkComponent implements OnInit {
  @Input() linkText: string = "Can't find your venue?";
  @Input() source: string;

  constructor(private _matDialog: MatDialog, private _loggingService: LoggingService) {}

  ngOnInit(): void {}

  onVenueRequestClick(): void {
    this._loggingService.logRemoteInfo("Venue Request link clicked", "CustomerVenueRequestLinkComponent.onVenueRequestClick", {
      [CommonLoggingProp.Workflow]: "RequestVenue",
      [CommonLoggingProp.WorkflowStep]: "ButtonClick",
      [CommonLoggingProp.WorkflowSource]: this.source ?? "CustomerVenueRequestLinkComponent",
    });

    this._matDialog.open<VenueRequestWizardDialogComponent, void, VenueRequestWizardDialogResult>(VenueRequestWizardDialogComponent, {
      autoFocus: false,
      restoreFocus: false,
    });
  }
}
